import React, { useEffect, useState } from "react";
import { TextField } from "@material-ui/core";
import { Col, Form, Row } from "react-bootstrap";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import { useSelector } from "react-redux";
import axios from "axios";
import { serverApi } from "../../../config/Keys";
import isEmpty from "../../../store/validation/is-Empty";
import en from "react-phone-number-input/locale/en.json";
import Alert from "react-s-alert";
import { NavLink } from "react-router-dom";
import { useHistory } from "react-router";

const CreditWithOutReference = (props) => {
  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });
  const [mobile, setMobile] = useState("");
  const [name, setName] = useState("");
  const [user, setUser] = useState(null);
  const [amount, setAmount] = useState({ value: "", check: false, text: "" });
  const [comment, setComment] = useState("");
  const [notifyUser, setNotifyUser] = useState(false);
  const [isSubmit, setIsSubmit] = useState(true);
  const [code, setCode] = useState("+91");
  const [error, setError] = useState({ check: false, text: "" });

  const history = useHistory();

  const changeMobile = (e) => {
    if (/^[6-9]{1}[0-9]{9}$/.test(e.target.value)) {
      setError({ check: false, text: "" });
      setMobile(e.target.value);
    } else {
      setMobile(e.target.value);
      setError({ check: true, text: "Enter Proper Number" });
    }
  };

  const getUser = async () => {
    let data = await axios.get(
      `${serverApi}/user-check?mobile_number=${mobile}&country_code=${code}`
    );
    if (!isEmpty(data.data)) {
      setError({ check: false, text: "" });
      setName(`${data.data.first_name} ${data.data.last_name}`);
      setUser(data.data);
    } else {
      setName("");
      setError({ check: true, text: "User Not Found" });
    }
  };

  const validateAmount = (e) => {
    if (/^[1-9]{1}[0-9]+$/.test(e.target.value)) {
      setAmount({ check: false, text: "", value: e.target.value });
    } else {
      setAmount({
        check: true,
        text: "Enter Proper Value",
        value: e.target.value,
      });
    }
  };

  const clearData = () => {
    setMobile("");
    setName("");
    setUser(null);
    setAmount({ value: "", check: false, text: "" });
    setComment("");
    setNotifyUser(false);
    setIsSubmit(true);
    setCode("+91");
    setError({ check: false, text: "" });
  };

  useEffect(() => {
    if (/^[6-9]{1}[0-9]{9}$/.test(mobile)) {
      getUser();
    }
  }, [mobile]);

  useEffect(() => {
    if (error.check && amount.check) {
      setIsSubmit(true);
    } else if (amount.value && name) {
      setIsSubmit(false);
    } else {
      setIsSubmit(true);
    }
  }, [error, amount]);

  const submitData = async (e) => {
    e.preventDefault();
    let submitData = {
      refund_amount: amount.value,
      comment: comment,
      memo_type: "CREDIT",
      payment_type: "WALLET",
      user_id: user._id,
    };
    let data = await axios.post(`${serverApi}/orderMemo`, submitData, {
      headers: {
        Authorization: auth.accessToken,
        "Content-Type": "application/json",
      },
    });
    if (data.status === 201) {
      Alert.success(`<h4>Credit Memo Add Successfully</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      history.push("/memolist");
      clearData();
    } else {
      Alert.error(`<h4>Something went Wrong, try again later</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

  return (
    <div className="mt-4">
      <Row>
        <Col md={4}>
          <Row>
            <Col xs={3} sm={3} md={3} lg={3} xl={3}>
              <Form.Group controlId={"code"}>
                <div className="input-phone-country-code-reusable w-100 ">
                  <select
                    name="code"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    className="w-100 pl-0"
                  >
                  <option
                  value={code
                   }
                  >
                    {
                      code
                    }
                  </option>
                    {getCountries().map((country) => (
                      <option
                        key={country}
                        value={"+" + getCountryCallingCode(country)}
                      >
                        {en[country]} (+{getCountryCallingCode(country)})
                      </option>
                    ))}
                  </select>
                </div>
              </Form.Group>
             { console.log(code,'*******country')}
            </Col>
            <Col xs={9}>
              <Form.Group>
                <TextField
                  id="mobile_number"
                  label="Phone Number"
                  type="number"
                  variant="outlined"
                  fullWidth
                  onChange
                  name="mobile_number"
                  error={error.check}
                  helperText={error.text}
                  onChange={changeMobile}
                />
              </Form.Group>
            </Col>
          </Row>
          <div className="mt-2 mb-2">
            <TextField
              variant="outlined"
              fullWidth
              label="Username"
              value={name}
              disabled
            />
          </div>
          <div className="mt-2 mb-2">
            <TextField
              variant="outlined"
              fullWidth
              label="Enter Amount"
              value={amount.value}
              onChange={validateAmount}
              error={amount.check}
              helperText={amount.text}
            />
          </div>
          <p className="f12-700 pt-4"> Comment Here </p>

          <div className="mt-2 mb-2">
            <TextField
              multiline
              rows={4}
              variant="outlined"
              fullWidth
              // label="Comment here"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </div>
          <div className="mt-2 mb-2">
            <input
              type="checkbox"
              name=""
              checked={notifyUser}
              onChange={() => setNotifyUser(!notifyUser)}
            />{" "}
            Notify Customer By Email
          </div>
          <div class="py-4 d-flex align-items-center mt-3 justify-content-center">
            <button
              type="button"
              class="btn-md mr-4 px-5 btn btn-outline-secondary"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn-md px-5 btn btn-danger"
              onClick={submitData}
              disabled={isSubmit}
            >
              Submit
            </button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default CreditWithOutReference;
